import { render, staticRenderFns } from "./TicketNoteVersionsModal.vue?vue&type=template&id=5f83028e&"
import script from "./TicketNoteVersionsModal.vue?vue&type=script&lang=js&"
export * from "./TicketNoteVersionsModal.vue?vue&type=script&lang=js&"
import style0 from "./TicketNoteVersionsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports